import { render } from "./CameraShotAttach.vue?vue&type=template&id=2e2ba036&ts=true"
import script from "./CameraShotAttach.vue?vue&type=script&lang=ts"
export * from "./CameraShotAttach.vue?vue&type=script&lang=ts"

import "./CameraShotAttach.vue?vue&type=style&index=0&id=2e2ba036&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__